import React from 'react'
import config from '../../../config'
import styled from 'styled-components'
import ReactTable from 'react-table'
import { filterCaseInsensitive } from '../../../util'
import moment from 'moment'
import { Link } from 'react-router-dom'
import {
  Button,
  Form,
  Modal,
  Popconfirm,
  Input,
  DatePicker,
  Icon,
  Radio,
  Spin,
  Tooltip,
  Upload,
  AutoComplete,
  Select
} from 'antd'

const { API_BASE } = config
const FormItem = Form.Item
const { TextArea } = Input
const RadioButton = Radio.Button
const RadioGroup = Radio.Group
const Option = Select.Option
const FilesUploadContainer = styled.div`
  padding: 10px;
  margin: 10px 0;
  border-radius: 4px;
  border: 1px solid #e2e2e2;
  -webkit-box-shadow: 0px 0px 35px -12px rgba(204, 204, 204, 1);
  -moz-box-shadow: 0px 0px 35px -12px rgba(204, 204, 204, 1);
  box-shadow: 0px 0px 35px -12px rgba(204, 204, 204, 1);
`

const EditAttachmentContainer = styled.div`
  padding: 10px;
  margin: 10px 0;
  border-radius: 4px;
  border: 1px solid #e2e2e2;
  background-color: #eeeeee;
`
const EditAttachmentTitle = styled.h6`
  color: #fff;
`
const EditingFileContainer = styled.div`
  margin: 10px 0;
`

const JobSiteDriverRequestModal = ({
  loadingRevision,
  contentData,
  templateOptions,
  currentRevisionNumberPrint,
  uploadProps,
  getFieldDecorator,
  revisions,
  handleSelectedTemplate,
  handleCancel,
  handleCreate,
  handleTemplateChange,
  handleRevisionChange,
  jobSiteDriverRequestActions,
  attachmentDetailsVisible,
  confirmDelete,
  cancelDelete,
  attachmentName,
  attachmentDescription,
  onDescriptionChange,
  handleUpdateAttachmentDescription,
  confirmAttachmentDelete,
  handleAttachmentRowClick,
  uploadAttachment
}) => (
  <Modal
    visible
    title="Driver Requests"
    okText={contentData ? 'Save Changes' : 'Create'}
    onCancel={handleCancel}
    onOk={handleCreate}
    maskClosable={false}
  >
    <Form layout="vertical">
      <div className="row">
        <div className="col-md-9">
          <FormItem label="Template">
            {getFieldDecorator('driver_request_template_id', {
              initialValue: handleSelectedTemplate(
                contentData && contentData.driver_request_template_id
              )
            })(
              <AutoComplete
                dataSource={templateOptions}
                filterOption={(inputValue, option) =>
                  option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                }
                onChange={handleTemplateChange}
              >
                <Input suffix={<Icon type="search" className="certain-category-icon" />} />
              </AutoComplete>
            )}
          </FormItem>
        </div>
        {contentData && (
          <div className="col-md-3">
            <FormItem label="Revision">
              {getFieldDecorator('revision', {
                initialValue:
                  revisions && revisions.length > 0 ? revisions[revisions.length - 1].id : null
              })(
                loadingRevision ? (
                  <Spin size="small" />
                ) : (
                  <Select onChange={handleRevisionChange}>
                    {revisions &&
                      revisions.map(revision => (
                        <Option key={revision.id} value={revision.id}>
                          {revision.revision}
                        </Option>
                      ))}
                  </Select>
                )
              )}
            </FormItem>
          </div>
        )}
      </div>
      {contentData && (
        <div className="row">
          <div className="col-md-11">
            <FormItem label="Status">
              {getFieldDecorator('completed', {
                initialValue: contentData ? contentData.completed : ''
              })(
                <RadioGroup>
                  <RadioButton value={0}>Created</RadioButton>
                  <RadioButton value={1}>Completed</RadioButton>
                </RadioGroup>
              )}
            </FormItem>
          </div>
          <div className="col-md-1">
            <a
              href={`${API_BASE}/api/job/job_site_driver_requests/print/${
                contentData.id
              }?revision=${currentRevisionNumberPrint}`}
              target="_blank"
            >
              <Button icon="printer" className="marginRight10" />
            </a>
          </div>
        </div>
      )}
      <FormItem label="Description">
        {getFieldDecorator('description', {
          rules: [
            {
              required: true,
              message: 'Note description cannot be blank.'
            }
          ],
          initialValue: contentData ? contentData.description : ''
        })(<TextArea placeholder="Describe the attachment..." rows={4} />)}
      </FormItem>
      <div className="row">
        <div className="col-md-6">
          <FormItem label="Requested By">
            {getFieldDecorator('requested_by', {
              rules: [
                {
                  required: true,
                  message: 'Must be requested by someone.'
                }
              ],
              initialValue: contentData ? contentData.requested_by : ''
            })(<Input placeholder="Type in requested by name..." />)}
          </FormItem>
        </div>
        <div className="col-md-6">
          <FormItem label="Requested Date">
            {getFieldDecorator('requested_date', {
              rules: [
                {
                  required: true,
                  message: 'Note requested_date cannot be blank.'
                }
              ],
              initialValue: contentData ? moment(contentData.requested_date) : null
            })(<DatePicker format="MM-DD-YYYY HH:mm" showTime />)}
          </FormItem>
        </div>
      </div>
      <div className="row">
        <div className="col-md-6">
          <FormItem label="Needed By Date">
            {getFieldDecorator('needed_by_date', {
              rules: [
                {
                  required: true,
                  message: 'Must have a Needed By Date.'
                }
              ],
              initialValue: contentData ? moment(contentData.needed_by_date) : null
            })(<DatePicker format="MM-DD-YYYY HH:mm" showTime />)}
          </FormItem>
        </div>
        <div className="col-md-6">
          <FormItem label="Point of Contact">
            {getFieldDecorator('point_of_contact', {
              initialValue: contentData ? contentData.point_of_contact : ''
            })(<Input placeholder="Type in point of contact..." />)}
          </FormItem>
        </div>
      </div>
      <FormItem label="Special Conditions">
        {getFieldDecorator('special_conditions', {
          initialValue: contentData ? contentData.special_conditions : ''
        })(
          <TextArea
            placeholder="Type in any special conditions..."
            rows={4}
            initialvalue={contentData ? contentData.special_conditions : ''}
          />
        )}
      </FormItem>
      {contentData &&
        contentData.scheduled_delivery &&
        contentData.scheduled_delivery.length > 0 && (
          <div>
            <h5>Scheduled Delivery</h5>
            <div>
              <div style={{ display: 'block' }}>
                {contentData.scheduled_delivery.length > 0
                  ? `Vehicle: ${contentData.scheduled_delivery[0].vehicle_name}`
                  : ''}
              </div>
              <div style={{ display: 'block' }}>
                {' '}
                {contentData.scheduled_delivery.length > 0
                  ? `Driver: ${contentData.scheduled_delivery[0].driver_first_name} ${
                      contentData.scheduled_delivery[0].driver_last_name
                    }`
                  : ''}
              </div>
              <div>
                {' '}
                {contentData.scheduled_delivery.length > 0 && (
                  <Link to={`/drivers/delivery/${contentData.scheduled_delivery[0].id}`}>
                    Scheduled Date:{' '}
                    {moment(contentData.scheduled_delivery[0].scheduled_date).format('M/D/YYYY')}
                  </Link>
                )}
              </div>
            </div>
          </div>
        )}
      {contentData && (
        <FilesUploadContainer>
          <div className="row">
            <div className="col-md-6">
              <h5>
                <Icon type="check" /> Driver Request Files
              </h5>
            </div>
            <div className="col-md-6 text-right">
              {jobSiteDriverRequestActions &&
                jobSiteDriverRequestActions.uploadingAttachment && (
                  <div className="text-success">
                    <Icon type="loading" /> Uploading File(s)
                  </div>
                )}
              {jobSiteDriverRequestActions &&
                jobSiteDriverRequestActions.deletingAttachment && (
                  <div className="text-danger">
                    <Icon type="loading" /> Deleting File(s)
                  </div>
                )}
            </div>
          </div>
          {jobSiteDriverRequestActions.jobDriverRequestAttachments &&
            jobSiteDriverRequestActions.jobDriverRequestAttachments.data.length > 0 && (
              <Spin spinning={jobSiteDriverRequestActions.loadingAttachments}>
                <ReactTable
                  defaultPageSize={5}
                  defaultFilterMethod={filterCaseInsensitive}
                  data={jobSiteDriverRequestActions.jobDriverRequestAttachments.data}
                  getTrProps={(state, rowInfo, column, instance) => ({
                    onClick: e => handleAttachmentRowClick(rowInfo.original)
                  })}
                  columns={[
                    {
                      Header: 'Attached Files',
                      columns: [
                        {
                          Header: 'Filename',
                          id: 'filename',
                          accessor: 'filename',
                          Cell: d => (
                            <Tooltip title={d.original.filename}>{d.original.filename}</Tooltip>
                          )
                        },
                        {
                          Header: 'Description',
                          id: 'description',
                          accessor: 'description',
                          Cell: d => (
                            <Tooltip title={d.original.description}>
                              {d.original.description}
                            </Tooltip>
                          )
                        },
                        {
                          Cell: row => (
                            <Tooltip placement="left" title="Open this file on a new window">
                              <a target="_blank" href={row.original.signedUrl}>
                                <Icon type="export" className="fontSize20" />
                              </a>
                            </Tooltip>
                          ),
                          maxWidth: 35
                        }
                      ]
                    }
                  ]}
                  defaultSorted={[
                    {
                      id: 'id',
                      desc: true
                    }
                  ]}
                  className="-striped -highlight"
                />
              </Spin>
            )}
          {attachmentDetailsVisible && (
            <EditAttachmentContainer>
              <EditAttachmentTitle>
                <Icon type="edit" /> Edit Attachment Area
              </EditAttachmentTitle>
              <div>
                <EditingFileContainer>
                  <Icon type="file" /> {attachmentName}
                </EditingFileContainer>
              </div>
              <div className="row">
                <div className="col-md-10">
                  <TextArea
                    placeholder="Describe the attachment..."
                    rows={4}
                    onChange={onDescriptionChange}
                    value={attachmentDescription}
                  />
                </div>
              </div>
              <div className="d-flex flex-row mt-2">
                <Button onClick={handleUpdateAttachmentDescription}>
                  <Icon type="save" /> OK
                </Button>{' '}
                <Popconfirm
                  title="Are you sure you want to delete this attachment?"
                  onConfirm={confirmAttachmentDelete}
                  okText="Yes"
                  cancelText="No"
                >
                  <Button type="danger" icon="delete" className="ml-2">
                    {' '}
                    DELETE
                  </Button>
                </Popconfirm>
              </div>
            </EditAttachmentContainer>
          )}
          <br />
          <div>Upload Driver Request File(s)</div>
          <br />
          <Upload {...uploadProps} name="file" customRequest={uploadAttachment}>
            <Button>
              <Icon type="upload" /> Upload
            </Button>
          </Upload>
        </FilesUploadContainer>
      )}
      <Popconfirm
        title="Are you sure you want to delete this record?"
        onConfirm={confirmDelete}
        onCancel={cancelDelete}
        okText="Yes"
        cancelText="No"
      >
        {contentData && <Button type="danger" icon="delete" />}
      </Popconfirm>
    </Form>
  </Modal>
)

export default JobSiteDriverRequestModal



// WEBPACK FOOTER //
// ./src/containers/job/tasks/JobSiteDriverRequestModal.js